import {params} from '../vars/params';

export const updateSvgScale = (): void => {
  const svgElement = document.getElementById('path-pc') as HTMLElement;
  if (svgElement) {
    const winWidth = window.innerWidth;
    let scaleX = winWidth / 1365; // 1365 is the original SVG width
    let scaleY = winWidth / 1365; // 4797 is the original SVG height
    scaleX = scaleX < 0.5 ? 0.5 : scaleX;
    scaleY = scaleY > 1.5 ? 1.5 : scaleY;
    scaleY = scaleY < 0.75 ? 0.75 : scaleY;
    svgElement.style.transform = `scaleX(${scaleX}) scaleY(${scaleY})`;
  }
};
